import { Modal, ThemeProvider } from 'react-bootstrap';
import './index.scss';

type ModalComponentType = {
    onAccept?: () => void;
    onReject?: () => void;
    header?: string;
    content?: null | JSX.Element;
    className?: string;
    width?: string;
    height?: string;
};

const ModalComponent = (props: ModalComponentType) => {
    const { header = null, content = null, onReject } = props;

    return (
        <ThemeProvider prefixes={{
            fade: 'vb-fade',
            modal: 'vb-modal',
            'modal-dialog': 'vb-modal-dialog',
            'modal-content': 'vb-modal-content',
            'modal-header': 'vb-modal-header',
            'modal-title': 'vb-modal-title',
            'modal-body': 'vb-modal-body',
            'modal-footer': 'vb-modal-footer',
            'btn-close': 'vb-btn-close',
            btn: 'vb-btn',
            'btn-secondary': 'vb-btn-secondary',
            'btn-primary': 'vb-btn-primary',
        }}>
            <Modal show={true} onHide={onReject}>
                <Modal.Header>
                    <Modal.Title>{header}</Modal.Title>
                    <button type="button" className='vb-btn-close' aria-label="Close" onClick={onReject}></button>
                </Modal.Header>
                <Modal.Body className='vb-p-0'>{content}</Modal.Body>
            </Modal>

        </ThemeProvider>
    );
};

export default ModalComponent;
